import React from 'react';
import { FiPlus } from 'react-icons/fi';
import { BsLayoutSidebarInset, BsLayoutSidebarInsetReverse, BsFillSunFill, BsSunFill } from 'react-icons/bs';
import useStore from '../../store/useStore';

/**
 * Componente de cabecera que muestra el logo, controles principales y opciones de usuario
 * Incluye manejo de tema claro/oscuro y control del historial de chats
 */
const Header = ({ className = '' }) => {
  const { 
    darkMode, 
    toggleDarkMode, 
    isRightSidebarOpen, // Usar el nuevo estado para el panel derecho
    toggleRightSidebar, // Usar la nueva acción para el panel derecho
    // sidebarOpen, // Conservar si es usado por otra cosa, sino marcar para eliminar
    // toggleSidebar, // Conservar si es usado por otra cosa, sino marcar para eliminar
    createNewChat,
    selectedAgent,
    agents,
  } = useStore();
  
  // La lógica del menú de usuario, incluyendo estados (userMenuOpen, userName, etc.),
  // useEffects para actualizar info de usuario y cerrar menú,
  // y la función handleLogout han sido movidos a Sidebar.js


  // Obtener información del agente seleccionado
  const selectedAgentData = agents.find(a => a.key === selectedAgent);

  // Mostrar el header incluso si no hay nombre o email para depuración
  // if (!userName && !userEmail) return null;

  return (
    <header className={`flex items-center justify-between px-6 py-3 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm ${className}`}>
      <div className="flex items-center">
        {/* Título del agente seleccionado */}
        {selectedAgent && (
          <h1 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
            {selectedAgentData?.name || 'Agente IA'}
          </h1>
        )}
        
        {/* Botón para nuevo chat */}
        {selectedAgent && (
          <button 
            onClick={createNewChat}
            className="flex items-center px-3 py-2 ml-4 rounded-md shadow-md text-sm font-medium transition-colors bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/50"
          >
            <FiPlus className="mr-1" size={16} />
            <span>Nuevo chat</span>
          </button>
        )}
      </div>

      <div className="flex items-center">
        {/* Botón de alternar tema */}
        <button 
          onClick={toggleDarkMode}
          className="p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          aria-label={darkMode ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
        >
          {darkMode ? <BsFillSunFill size={20} /> : <BsSunFill size={20} />}
        </button>

        {/* Botón para mostrar/ocultar historial */}
        {selectedAgent && (
          <div className="relative group ml-1">
            <button 
              onClick={toggleRightSidebar}
              className="p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all duration-200 ease-in-out"
              aria-label={isRightSidebarOpen ? "Ocultar historial" : "Mostrar historial"}
            >
              {isRightSidebarOpen ? <BsLayoutSidebarInset size={20} /> : <BsLayoutSidebarInsetReverse size={20} />}
            </button>
            <span className="absolute right-full top-1/2 -translate-y-1/2 mr-3 z-50 px-3 py-1.5 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md shadow-lg border border-slate-200 dark:border-slate-700 opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-200 ease-out delay-150 pointer-events-none whitespace-nowrap">
              {isRightSidebarOpen ? "Ocultar historial" : "Mostrar historial"}
            </span>
          </div>
        )}

        {/* El menú de usuario ha sido movido al Sidebar */}
      </div>
    </header>
  );
};

export default Header;
